<template>
  <div>
    <v-row>
      <v-col>
        <span class="text-subtitle-2">{{ title }}</span>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <slot name="cep">
          <Cep
            label="CEP"
            v-model="cepModel"
            :required="isRequired"
            :model-names="modelNames"
            :clear-model="true"
            :model-endereco="enderecoModel"
            :dados-via-cep.sync="dadosViaCep"
          />
        </slot>
      </v-col>
      <v-col cols="12" md="8">
        <slot name="logradouro">
          <input-text
            label="Logradouro"
            v-model="logradouroModel"
            :required="isRequired"
            :disabled="dadosViaCep"
          />
        </slot>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <slot name="bairro">
          <input-text
            label="Bairro"
            v-model="bairroModel"
            :disabled="dadosViaCep"
          />
        </slot>
      </v-col>
      <v-col cols="6" md="2">
        <slot name="numero">
          <input-number
            :required="isRequired"
            label="Número"
            v-model="numeroModel"
            cep-numero
          />
        </slot>
      </v-col>
      <v-col cols="6" md="6">
        <slot name="complemento">
          <input-text
            label="Complemento"
            v-model="complementoModel"
          />
        </slot>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <slot name="estado">
          <input-select
            :options="$aux.UF"
            item-value="UF"
            item-text="Nome"
            :required="isRequired"
            label="Estado"
            v-model="ufModel"
            :disabled="dadosViaCep"
          />
        </slot>
      </v-col>
      <v-col cols="12" md="8">
        <slot name="cidade">
          <input-text
            label="Cidade"
            v-model="cidadeModel"
            :disabled="dadosViaCep"
          />
        </slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Cep from './Cep.vue'

export default {
  components: {
    Cep
  },
  props: {
    value: null,
    title: {
      type: String,
      default: 'Endereço'
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    modelNames: {
      type: Object,
      default: () => ({
        CEP: 'CEP',
        logradouro: 'Logradouro',
        bairro: 'Bairro',
        uf: 'UF',
        localidade: 'Cidade',
        numero: 'NroLogradouro',
        complemento: 'Complemento'
      })
    },
    modelEndereco: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dadosViaCep: false
    }
  },
  watch: {
    'model.CEP' (val) {
      if (!val || val.length < 8) {
        this.dadosViaCep = false
      }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    enderecoModel () {
      return this.modelEndereco || this.value
    },
    cepModel: {
      get () {
        return this.enderecoModel[this.modelNames.CEP]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.CEP, value)
      }
    },
    logradouroModel: {
      get () {
        return this.enderecoModel[this.modelNames.logradouro]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.logradouro, value)
      }
    },
    bairroModel: {
      get () {
        return this.enderecoModel[this.modelNames.bairro]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.bairro, value)
      }
    },
    ufModel: {
      get () {
        return this.enderecoModel[this.modelNames.uf]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.uf, value)
      }
    },
    cidadeModel: {
      get () {
        return this.enderecoModel[this.modelNames.localidade]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.localidade, value)
      }
    },
    numeroModel: {
      get () {
        return this.enderecoModel[this.modelNames.numero]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.numero, value)
      }
    },
    complementoModel: {
      get () {
        return this.enderecoModel[this.modelNames.complemento]
      },
      set (value) {
        this.$set(this.enderecoModel, this.modelNames.complemento, value)
      }
    }
  }
}
</script>
